import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { AppBar, IconButton, Tab, Tabs, Toolbar } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HouseIcon from '@mui/icons-material/House';

import appdata from '../../Services/appdata';
import CompanySettings from '../CompanySettings';
import SecuritySettings from '../SecuritySettings';
import ManageReportData from '../ManageReportData';
import BudgetForecastCashflow from '../BudgetForecastCashflow';
import ManageReportConfig from '../ManageReportConfig';

function Settings() {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [roles, setRoles] = useState([]);
  const [tabs, setTabs] = useState([]);

  const pageTypes = useMemo(() => {
    let pages = [];
    if (roles.indexOf('CompanySettings') > -1) {
      pages.push('company');
    }
    if (roles.indexOf('SecuritySettings') > -1) {
      pages.push('security');
    }
    if (roles.indexOf('ManagementReportingData') > -1) {
      pages.push('managereport');
    }
    if (roles.indexOf('BudgetForecastCashflow') > -1) {
      pages.push('budgetforecastcashflow');
    }
    if (roles.indexOf('ManagementReportingConfig') > -1) {
      pages.push('managereportconfig');
    }

    return pages;
  }, [roles]);
  
  useEffect(() => {
    const path = window.location.pathname;
    var words = path.split('/');
    const type = words[words.length - 1];

    let role_pages = appdata.getItem('changedrole').pages;
    let page_types = [];
    
    if (role_pages.indexOf('CompanySettings') > -1) {
      page_types.push('company');
    }
    if (role_pages.indexOf('SecuritySettings') > -1) {
      page_types.push('security');
    }
    if (role_pages.indexOf('ManagementReportingData') > -1) {
      page_types.push('managereport');
    }
    if (role_pages.indexOf('BudgetForecastCashflow') > -1) {
      page_types.push('budgetforecastcashflow');
    }
    if (role_pages.indexOf('ManagementReportingConfig') > -1) {
      page_types.push('managereportconfig');
    }
    
    let tab_index = page_types.indexOf(type);
    if (tab_index === -1) {
      tab_index = 0;
    }
    setTabIndex(tab_index);

    let roles = appdata.getItem('changedrole').pages;
    let tabs = [];

    roles.forEach(role => {
      if (role.includes('CompanySettings')) {
        tabs.push({
          id: role,
          name: 'Company',
        });
      }

      if (role.includes('SecuritySettings')) {
        tabs.push({
          id: role,
          name: 'Security',
        });
      }

      if (role.includes('ManagementReportingData')) {
        tabs.push({
          id: role,
          name: 'Management Reporting Data',
        });
      }

      if (role.includes('BudgetForecastCashflow')) {
        tabs.push({
          id: role,
          name: 'Budget/Forecast/Cashflow',
        });
      }

      if (role.includes('ManagementReportingConfig')) {
        tabs.push({
          id: role,
          name: 'Management Reporting Config',
        });
      }
    });
    setRoles(roles);
    setTabs(tabs);
  }, []);

  const onSignout = () => {
    appdata.localClear();
    appdata.clear();
  };

  const handleChangeTab = (event, tabIndex) => {
    navigate('/home/settings/' + pageTypes[tabIndex]);
    setTabIndex(tabIndex);
  };
  
  return (
    <div className="settings-page">
      <AppBar position="relative" color="default">
        <Toolbar>
          <IconButton onClick={() => navigate('/')}>
            <HouseIcon />
          </IconButton>

          <Tabs
            value={tabIndex}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            style={{ width: 'calc(100% - 130px)' }}
            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
          >
            {tabs.map((tab) => (
              <Tab key={tab.id} label={tab.name} />
            ))}
          </Tabs>

          <IconButton onClick={onSignout} className="sign-out-but">
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {tabs.length > 0 && (
        <div style={{ height: '89.5vh' }}>
          {tabs[tabIndex]?.id === 'CompanySettings' && <CompanySettings />}
          {tabs[tabIndex]?.id === 'SecuritySettings' && <SecuritySettings />}
          {tabs[tabIndex]?.id === 'ManagementReportingData' && <ManageReportData />}
          {tabs[tabIndex]?.id === 'BudgetForecastCashflow' && <BudgetForecastCashflow />}
          {tabs[tabIndex]?.id === 'ManagementReportingConfig' && <ManageReportConfig />}
        </div>
      )}
    </div>
  );
}

export default Settings;
